module.exports = __webpack_public_path__ + "img/icon-化学@2x.3ce51a52.png";